export default __webpack_public_path__ + "static/media/vimeo.e52170df.png";